import { render } from "./cardIcon.vue?vue&type=template&id=ef8ecf34&scoped=true"
import script from "./cardIcon.vue?vue&type=script&lang=js"
export * from "./cardIcon.vue?vue&type=script&lang=js"

import "./cardIcon.vue?vue&type=style&index=0&id=ef8ecf34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8ecf34"]])

export default __exports__